import { Dialog } from '@ordr-as/umami-react/dialog';
import useIntl from '../../../../../../hooks/useIntl';
import { useCheckout } from '../../../../../../context/CheckoutContext';
import FormattedMessage from '../../../../../../components/FormattedMessage';
import { useLocation } from '../../../../../../context/LocationContext';
import { useScreenSize } from '../../../../../../context/ScreenSizeContext';
import { useNavigate } from 'react-router-dom';
import { Dispatch, SetStateAction } from 'react';
import { useCartStore } from '../../../../../../context/cart/CartStore';

type EmptyCartDialogProps = {
  setOpenEmptyCartDialog: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
};

const EmptyCartDialog = (props: EmptyCartDialogProps) => {
  const { setOpenEmptyCartDialog, isOpen } = props;
  const intl = useIntl();
  const { location } = useLocation();
  const { emptyCart, setAppliedDiscount } = useCartStore((state) => ({
    emptyCart: state.resetCart,
    setAppliedDiscount: state.applyDiscount,
  }));

  const { setToDefaultDeliveryMethod } = useCheckout();
  const { isPhone } = useScreenSize();
  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }

  const handleEmptyCart = () => {
    emptyCart();
    setToDefaultDeliveryMethod();
    setAppliedDiscount(undefined);
    setOpenEmptyCartDialog(false);

    if (isPhone) {
      navigate(`/${location.locationId}`);
    }
  };

  return (
    <Dialog
      className="w-full mx-4 tablet:w-1/2 tablet:mx-0"
      onClose={() => setOpenEmptyCartDialog(false)}
      title={intl.formatMessage({ id: `checkout.emptyCart.title` })}
      onAction={handleEmptyCart}
      actionLabel={intl.formatMessage({ id: 'generic.empty' })}
      onSecondaryAction={() => setOpenEmptyCartDialog(false)}
      secondaryActionLabel={intl.formatMessage({ id: 'generic.cancel' })}
    >
      <p>
        <FormattedMessage id="checkout.emptyCart.content" />
      </p>
    </Dialog>
  );
};

export default EmptyCartDialog;
